module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/leave/leave.component.html
// module id = ./src/app/modules/leave/leave.component.html
// module chunks = main